var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-h6 primary--text"},[_vm._v("Sorry, this page does not exist.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }